import React from 'react'
import { formatHour, formatMoney } from '../../../helpers/utils'
import {
  formatPendingSettlementCount,
  renderPendingSettlementLabel,
  SETTLEMENT_STATUS_HEADER_DELIVERIES
} from '../helpers/pendingSettlement'
import { createReportDetailsTab } from './createReportDetailsTab'

const HEADERS = [
  { label: 'CÓDIGO', description: 'Número de identificación del usuario' },
  { label: 'USUARIO', description: 'Nombre del usuario' },
  { label: 'ÚLTIMA ACTIVIDAD', description: 'Hora de última actividad registrada' },
  { label: 'VISITAS REALIZADAS', description: 'Cantidad total de visitas registradas' },
  { label: 'VISITAS FUERA DE RUTA', description: 'Visitas que no estaban asignadas' },
  { label: 'DOCUMENTOS ENTREGADOS', description: 'Documentos entregados vs total por entregar' },
  {
    label: 'EFECTIVIDAD VISITA/ENTREGAS',
    description: 'Porcentaje visitas vs entregas realizadas'
  },
  {
    label: 'ACTIVIDADES DENTRO DE GEOCERCA',
    description: 'Actividades dentro de la zona permitida'
  },
  {
    label: 'TOTAL DE RECHAZOS',
    description: 'Sumatoria total de rechazos hechos por el usuario'
  },
  SETTLEMENT_STATUS_HEADER_DELIVERIES,
  {
    label: 'ENTREGAS PENDIENTES POR LIQUIDAR',
    description: 'Indica si el usuario tiene entregas del día que todavía no ha liquidado, incluso si ya liquidó otras entregas anteriormente ese mismo día.'
  },
  { label: 'TOTAL DE ENTREGAS', description: 'Sumatoria total de entregas hechas por el usuario' }
]

function renderRow(model, { isSingleDayRange = true } = {}) {
  return (
    <>
      <td>{model.user_uid}</td>
      <td>{model.user_name}</td>
      <td className="text-center">{formatHour(model.delivery_last_visit)}</td>
      <td className="text-center">
        {model.total_visited_clients}/{model.all_executed_clients}
      </td>
      <td className="text-center">{model.out_of_route_clients}</td>
      <td className="text-center">
        {model.delivery_documents_closed_count}/{model.delivery_documents_total_count}
      </td>
      <td className="text-center">{model.delivery_percent_effectiveness}%</td>
      <td className="text-center">
        {model.delivery_location_effective_count}/{model.delivery_location_available_count}
      </td>
      <td className="text-center">{formatMoney(model.total_delivery_rejected)}</td>
      <td className="text-center">
        {renderPendingSettlementLabel(model.settlement_status, isSingleDayRange)}
      </td>
      <td className="text-center">
        {formatPendingSettlementCount(model.pending_deliveries_settlement_count, isSingleDayRange)}
      </td>
      <td className="text-center">{formatMoney(model.total_delivery)}</td>
    </>
  )
}

export default createReportDetailsTab({
  displayName: 'ReportDeliveriesTab',
  headers: HEADERS,
  renderRow,
  supportsSettlement: true
})
